import { SponsorsSection } from '@/components/molecules';
import { TEAM_LEAGUE_MODULE_FOR } from '@/hooks/constants';
import { getSponsorsController } from '@/interface-adapters/controllers/leagues/get-sponsors.controller';

export const SponsorsList = async ({ teamLeagueUuid }: { teamLeagueUuid: string }) => {
	const sponsorsInfo = await getSponsorsController(teamLeagueUuid, TEAM_LEAGUE_MODULE_FOR);

	if (!sponsorsInfo.data || sponsorsInfo?.data?.length == 0) {
		return null;
	}

	return (
		<div className="flex w-[320px] flex-col gap-6 pt-4 md:pt-6">
			{sponsorsInfo.data.map((sponsors) => (
				<SponsorsSection key={sponsors.sponsorLevelId} sponsorLevel={sponsors} />
			))}
		</div>
	);
};
